import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "as", "pageType", "slug", "url"];
import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import BaseLink from '../../../../../atoms/Link';
import { cleanLinkProps, sortLinks } from '../../../../../modules/navigation/services/links';
import { isExternalPage } from '../../../../../services/pages';
import { AsPropType, SiteNavigationLinkPropType } from '../../../../../services/proptypes';
var defaultProps = {
  linksAs: 'a'
};
function DropdownMenu(_ref) {
  var title = _ref.title,
    options = _ref.options,
    linksAs = _ref.linksAs;
  var sortedOptions = sortLinks(options);
  var cleanedOptions = cleanLinkProps(sortedOptions);
  return /*#__PURE__*/React.createElement(Dropdown, {
    item: true,
    text: title
  }, /*#__PURE__*/React.createElement(Dropdown.Menu, null, cleanedOptions.map(function (_ref2) {
    var linkTitle = _ref2.title,
      as = _ref2.as,
      pageType = _ref2.pageType,
      slug = _ref2.slug,
      url = _ref2.url,
      rest = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement(Dropdown.Item, {
      key: linkTitle
    }, /*#__PURE__*/React.createElement(BaseLink, _extends({
      to: isExternalPage(pageType) ? url : slug,
      as: as || linksAs,
      title: linkTitle,
      internal: !isExternalPage(pageType)
    }, rest)));
  })));
}
DropdownMenu.defaultProps = defaultProps;
export default DropdownMenu;